import { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Grid,
  Box,
  Divider,
  IconButton,
  Typography,
  Tooltip,
} from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
// import ArchiveIcon from "@mui/icons-material/Archive";
import ForwardIcon from "@mui/icons-material/Forward";
import PrintIcon from "@mui/icons-material/Print";
import EmailIcon from "@mui/icons-material/Email";
import ViewMessageModal from "./ViewMessageModal";
import SelectedMessageDetails from "./SelectedMessageDetails";
import * as actionTypes from "../../state/actionTypes";
import { useReactToPrint } from "react-to-print";
// import JsPDF from "jspdf";
// import html2canvas from "html2canvas";
import MailModal from "../MailModal";

/**
 *
 * @param {Object} message Object of a selected message
 * @param {Object} messageDetails Array of a selected message details
 * @param {Number} messagesCount count of total current type's messages
 * @param {Number} messageIndex index of current message
 * @param {Object} currentTypeMessages Array of all current type's messages
 * @returns
 */
const SelectedMessage = ({
  message,
  messageDetails,
  messageTreeDetails,
  messagesCount,
  messageIndex,
  currentTypeMessages,
  success,
  error,
}) => {
  const dispatch = useDispatch();
  const [viewMessage, setViewMessage] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);

  const [isMailModalOpen, setIsMailModalOpen] = useState(false);

  //view message handler
  const ViewMessageToggler = () => {
    setViewMessage(!viewMessage);
  };

  //printing refs
  const messageRef = useRef(null); //component to print ref
  const onBeforeGetContentRef = useRef(); //a ref for a promise resolve

  //next and prev message handlers
  const handleNextMessage = () => {
    if ((messageIndex === messagesCount - 1) === 0) return 0;

    let nextIndex;
    if (messageIndex < messagesCount - 1) nextIndex = messageIndex + 1;
    else nextIndex = 0;

    const nextMessage = currentTypeMessages[nextIndex];

    dispatch({
      type: actionTypes.SET_CURRENT_MESSAGE,
      payload: nextMessage.header.referenceNumber,
    });
  };

  const handlePrevMessage = () => {
    if ((messageIndex === messagesCount - 1) === 0) return 0;

    let prevIndex;
    if (messageIndex > 0) prevIndex = messageIndex - 1;
    else prevIndex = messagesCount - 1;

    const prevMessage = currentTypeMessages[prevIndex];

    dispatch({
      type: actionTypes.SET_CURRENT_MESSAGE,
      payload: prevMessage.header.referenceNumber,
    });
  };

  //before get content to print handler (returns a promise so the print preview dialoge waits for the state of 'printing' to finish updating)
  const handleOnBeforeGetContent = () => {
    return new Promise((resolve) => {
      setIsPrinting(true); //set printing state to true (a dependency for hidden and shown content in the print[])
      onBeforeGetContentRef.current = resolve; //to resolve the promise right after the printing state is updated
    });
  };

  const handlePrint = useReactToPrint({
    content: () => messageRef.current,
    documentTitle: message?.header?.referenceNumber,
    onBeforeGetContent: handleOnBeforeGetContent,

    onAfterPrint: () => {
      setIsPrinting(false);
    },
  });

  // const handleExport = useReactToPrint({
  //   content: () => messageRef.current,
  //   documentTitle: message?.header?.referenceNumber,
  //   onBeforeGetContent: handleOnBeforeGetContent,

  //   onAfterPrint: () => {
  //     setIsPrinting(false);
  //   },

  //   print: async (printIframe) => {
  //     const doc = printIframe.contentWindow.document;
  //     const comments = doc.querySelectorAll(".show-in-export");
  //     comments.forEach((comment) => {
  //       comment.style.display = "flex";
  //     });

  //     const elementsToHide = doc.querySelectorAll(".hide-in-export");
  //     elementsToHide.forEach((element) => {
  //       element.style.display = "none";
  //     });

  //     html2canvas(printIframe.contentWindow.document.body).then((canvas) => {
  //       const base64Image = canvas.toDataURL("image/png");
  //       const doc = new JsPDF({
  //         orientation: "a4",
  //         unit: "px",
  //         format: [3508, 2480],
  //       });
  //       doc.addImage(base64Image, "PNG", 15, 15, 3400, 2400);

  //       doc.save("corzap-message.pdf");
  //     });
  //   },
  // });

  //resolve onBeforeGetContent promise right after printing state is updated
  useEffect(() => {
    if (isPrinting) {
      setTimeout(() => {
        onBeforeGetContentRef.current();
      }, [500]);
    }
  }, [isPrinting, onBeforeGetContentRef]);

  return (
    <Box sx={{ backgroundColor: "#ffffff", minHeight: "100%" }}>
      {!message ? (
        <Typography
          sx={{
            margin: "auto",
            width: "40%",
            paddingTop: "10%",
            color: "#50566E",
            fontWeight: 550,
            fontSize: ".875rem",
            opacity: 0.85,
            height: "100%",
          }}
        >
          No message selected
        </Typography>
      ) : (
        <>
          {viewMessage ? (
            <ViewMessageModal
              message={message}
              messageDetails={messageDetails}
              handleClose={ViewMessageToggler}
              handlePrint={handlePrint}
            />
          ) : null}
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            sx={{ height: "50px", paddingRight: "20px", paddingLeft: "20px" }}
          >
            <Grid item>
              <Typography
                sx={{ color: "#050D2E", fontSize: "1rem", fontWeight: "550" }}
              >
                {message.header.referenceNumber}
              </Typography>
            </Grid>
            <Grid item sx={{ display: "flex" }}>
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  alignItems: "center",
                  borderRight: "1px solid #50566E",
                  paddingRight: "5px",
                  paddingLeft: "5px",
                }}
              >
                <Tooltip title="Message history">
                  <IconButton
                    sx={{
                      background:
                        "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)",
                      borderRadius: "5px",
                      color: "#050D2E",
                      border: "1px solid #CFD7DF",
                    }}
                    variant="solid"
                    size="small"
                  >
                    <HistoryIcon fontSize="20px" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="view">
                  <IconButton
                    sx={{
                      background:
                        "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)",
                      borderRadius: "5px",
                      color: "#050D2E",
                      border: "1px solid #CFD7DF",
                    }}
                    variant="solid"
                    size="small"
                    onClick={ViewMessageToggler}
                  >
                    <RemoveRedEyeIcon fontSize="20px" />
                  </IconButton>
                </Tooltip>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  alignItems: "center",
                  borderRight: "1px solid #50566E",
                  paddingRight: "5px",
                  paddingLeft: "5px",
                }}
              >
                <Tooltip title="email">
                  <IconButton
                    sx={{
                      background:
                        "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)",
                      borderRadius: "5px",
                      color: "#050D2E",
                      border: "1px solid #CFD7DF",
                    }}
                    variant="solid"
                    size="small"
                    onClick={() => setIsMailModalOpen(true)}
                  >
                    <EmailIcon fontSize="20px" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="print">
                  <IconButton
                    sx={{
                      background:
                        "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)",
                      borderRadius: "5px",
                      color: "#050D2E",
                      border: "1px solid #CFD7DF",
                    }}
                    variant="solid"
                    size="small"
                    onClick={handlePrint}
                  >
                    <PrintIcon fontSize="20px" />
                  </IconButton>
                </Tooltip>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  alignItems: "center",
                  paddingLeft: "5px",
                }}
              >
                <Tooltip title="previous">
                  <IconButton
                    sx={{
                      background:
                        "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)",
                      borderRadius: "5px",
                      color: "#050D2E",
                      border: "1px solid #CFD7DF",
                      transform: "rotate(180deg)",
                    }}
                    variant="solid"
                    size="small"
                    onClick={handlePrevMessage}
                  >
                    <ForwardIcon fontSize="20px" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="next">
                  <IconButton
                    sx={{
                      background:
                        "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)",
                      borderRadius: "5px",
                      color: "#050D2E",
                      border: "1px solid #CFD7DF",
                    }}
                    variant="solid"
                    size="small"
                    onClick={handleNextMessage}
                  >
                    <ForwardIcon fontSize="20px" />
                  </IconButton>
                </Tooltip>

                {/* <IconButton
                  sx={{
                    background:
                      "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)",
                    borderRadius: "5px",
                    color: "#050D2E",
                    border: "1px solid #CFD7DF",
                  }}
                  variant="solid"
                  size="small"
                  onClick={handleExport}
                >
                  <ArchiveIcon fontSize="20px" />
                </IconButton> */}
              </Box>
            </Grid>
          </Grid>
          <Divider sx={{ marginBottom: "20px" }} />
          <SelectedMessageDetails
            messageDetails={messageDetails}
            messageTreeDetails={messageTreeDetails}
            referenceNumber={message.header.referenceNumber}
            ref={messageRef}
            isPrinting={isPrinting}
          />

          {isMailModalOpen && (
            <MailModal
              handleClose={() => setIsMailModalOpen(false)}
              referenceNumbers={[message.header.referenceNumber]}
              success={success}
              error={error}
            />
          )}
        </>
      )}
    </Box>
  );
};

export default SelectedMessage;
//   id: "0008045014032283",
//   rawFormat:
//     "{Transfers and accounts - checks of the customers of the institutions}{103STP  —  STP Single Customer Credit Transfer},[{ 111, '001' }{ 121, '69cbce88-066c-4731-8518-e3af973c24b2' }",
//   FIN: {
//     category:
//       "Transfers and accounts - checks of the customers of the institutions",
//     mt: "103STP  —  STP Single Customer Credit Transfer",
//     way: "From Swift",
//     originInst: "Swift",
//   },
//   sender: {},
//   reciever: {},
//   gpi: [
//     { no: 111, value: "001" },
//     { no: 121, value: "69cbce88-066c-4731-8518-e3af973c24b2" },
//   ],
// };
